import Cookies from 'universal-cookie';
export function isAnalyticalCookieSet() {
  const cookieService = new Cookies();
  const gdprPreferencesCookie = cookieService.get('gdpr_preferences');
  return gdprPreferencesCookie?.categories?.includes('analytical');
}